/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IEventId, ISuccess, TSuccessString } from '../interfaces';

export const EVENT_HTTP_SERVICE_START = 'HttpServiceEventStart';
export const EVENT_HTTP_SERVICE_STOP = 'HttpServiceEventStop';

/**
 * Additional properties to send along with ending a request
 */
export interface IEventHttpServiceStopProperties extends IEventId, ISuccess<TSuccessString> {
    statusCode: string;
}
